import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  Form,
  Button,
  Select,
  message,
  Radio,
  Pagination,
  Card,
  Input,
  Empty,
} from "antd";
import useJDStore from "../../store/jd.store";
import "./GlobalEvaluation.scss";
import PlusIcon from "../../assets/plus.png";
import EvaluationDescriptions from "../evaluationDescriptions";
import EvaluationSetup from "../evaluationSetup";
import RTable from "../RTable";
import useQCEStore from "../../store/qce.store";
import useGlobalQCEStore from "../../store/globalqce.store";
import { WarningOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { EVALUATIONS_COLUMNS_WIDTH } from "../../helper/tablewidthcontants";
import { FILTER_DURATION_OPTIONS } from "../../helper/categoryconstants";

const { Search } = Input;

function GlobalEvaluation() {
  const [evalView, setEvalView] = useState("all");
  const [selectedEvID, setEVID] = useState(0);
  const [setCurrentAllJDEvals] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(12);
  const [evalFilters, setEvalFilters] = useState({
    skill: "",
    state: "",
    duration: "",
    page: "",
    limit: "",
  });

  const {
    getAllGlobalEvals,
    allGlobalEvals,
    globalUpdateFlagQ,
    allGlobalEvalsPagination,
  } = useGlobalQCEStore();

  //   const { value } = useParams();
  const value = null;

  //when updated
  useEffect(() => {
    if (globalUpdateFlagQ) {
      getAllGlobalEvals(evalFilters);
    }
  }, [globalUpdateFlagQ]);

  //init
  useEffect(() => {
    getAllGlobalEvals();
    console.log("getAllGlobalEvals");
  }, [evalView]);

  const getAllEvaluations = () => {
    getAllGlobalEvals(evalFilters);
    setEvalView("all");
  };

  const handlePlusIcon = () => {
    setEvalView("settings");
  };

  const handleSpeceficEVID = (rowidx) => {
    setEVID(allGlobalEvals?.[rowidx]?.qhevid);
    setEvalView("specific");
  };

  function getEval(evid) {
    for (let idx = 0; idx < allGlobalEvals?.length; idx++) {
      if (allGlobalEvals?.[idx].qhevid == evid) {
        console.log("allGlobalEvals?.[idx]", allGlobalEvals?.[idx]);
        return allGlobalEvals?.[idx];
      }
    }
  }

  function getCapitalizedSkillString(skills) {
    if (!skills || skills.length === 0) return "";

    return skills
      .map((item) => {
        const skill = item.skill;
        // Capitalize the first letter and add the rest of the word
        return skill.charAt(0).toUpperCase() + skill.slice(1);
      })
      .join(", ");
  }

  const objectStyles = {
    root: {
      backgroundColor: "#fff",
      border: "1px solid #d9d9d9",
      borderRadius: "4px",
    },
    item: {
      padding: "8px 12px",
      fontSize: "14px",
    },
    itemTitle: {
      fontWeight: "500",
    },
    itemIcon: {
      color: "#1890ff",
      marginInlineEnd: "8px",
    },
    itemContent: {
      backgroundColor: "transparent",
    },
  };

  const handleFilterChange = (key, value) => {
    console.log("Cascader selected filters:", key);
    console.log("Cascader selected filters:", value);
    const updatedFilters = {
      ...evalFilters,
      [key]: value,
    };

    setEvalFilters(updatedFilters);
    console.log(updatedFilters, "before ending api");
    getAllGlobalEvals(updatedFilters);
  };

  const handlePageChange = (page, pageSize) => {
    getAllGlobalEvals({ ...evalFilters, page, limit: pageSize });
    setCurrentPage(page);
    setLimit(pageSize);
  };

  return (
    <div className="all-global-evaluations-form-wrapper">
      {evalView === "specific" ? (
        <>
          <div className="evaluations-form-title-wrapper">
            <div className="evaluations-form-title">Evaluation Marketplace</div>
            <div className="evaluations-form-item">
              <Button onClick={() => setEvalView("all")}>Back</Button>
            </div>
          </div>

          <EvaluationDescriptions
            setView={setEvalView}
            qhjid={value}
            evid={selectedEvID}
            exist={true}
            evalDesc={getEval(selectedEvID)}
            globalEvaluationPage={true}
          />
        </>
      ) : evalView === "settings" ? (
        <>
          <div className="evaluations-form-title-wrapper">
            <div className="evaluations-form-title">Create New Assement </div>
            <div className="evaluations-form-title-item">
              <Button onClick={() => getAllEvaluations()}>Back</Button>
            </div>
          </div>
          <EvaluationSetup
            setView={setEvalView}
            qhjid={value}
            exist={false}
            evalDesc={getEval(selectedEvID)}
            globalEvaluationPage={true}
          />
        </>
      ) : (
        <>
          <div className="evaluations-form-item-wrapper">
            <div className="evaluations-form-title">Evaluation Marketplace</div>
          </div>

          <div className="evaluations-filter-item-search">
            <Search
              placeholder="Type to search"
              onSearch={(value) => handleFilterChange("skill", value)}
              enterButton
              style={{ width: 400 }}
            />
          </div>

          {/* Dropdown Filters Section */}
          <div className="evaluations-filter-item-create-btn-wrapper">
            <div className="evaluations-filter-item-others">
              {/* First Filter */}
              <div className="evaluations-filter-item-wrapper">
                <div className="teamTask-filter-item-label">Status</div>
                <div className="teamTask-filter-item">
                  <Select
                    style={{ width: 130, height: 24 }}
                    onChange={(value) => handleFilterChange("state", value)}
                    showSearch={true}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    value={evalFilters?.state || "All"}
                    options={[
                      {
                        value: "",
                        label: "All",
                      },
                      {
                        value: "Live",
                        label: "Online",
                      },
                      {
                        value: "Offline",
                        label: "Offline",
                      },
                    ]}
                  />
                </div>
              </div>

              {/* Second Filter */}
              <div className="evaluations-filter-item-wrapper">
                <div className="teamTask-filter-item-label">Updated On</div>
                <div className="teamTask-filter-item">
                  <Select
                    style={{ width: 130, height: 24 }}
                    onChange={(value) => handleFilterChange("duration", value)}
                    showSearch={true}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    value={evalFilters?.duration || "All"}
                    options={FILTER_DURATION_OPTIONS}
                  />
                </div>
              </div>
            </div>

            <div className="evaluations-form-item">
              <div>Create New Assessment</div>
              <img
                src={PlusIcon}
                alt="Plus"
                width="20"
                height="20"
                className="image"
                onClick={handlePlusIcon}
              />
            </div>
          </div>
          {allGlobalEvals?.length > 0 ? (
            <div className="evaluations-form-card-wrapper">
              {allGlobalEvals?.map((evalItem, idx) => (
                <div className="evaluations-form-title-item">
                  <Card
                    key={evalItem.id || idx}
                    hoverable
                    style={{
                      height: 150,
                      borderColor:
                        evalItem?.state?.toLowerCase() === "live"
                          ? "#52c41a"
                          : "", // Your hex code here
                    }}
                    styles={{ body: { height: "100%" } }}
                    onClick={() => handleSpeceficEVID(idx)}
                  >
                    <div className="card-section">
                      <div className="card-section-top">
                        <div className="title-top">
                          <div
                            className="title-skills"
                            title={evalItem.generalsetting.name}
                          >
                            {evalItem.generalsetting.name}
                          </div>
                          <div className="title-questions">
                            {evalItem.generalsetting.totalq} Questions
                          </div>
                        </div>
                        <div
                          className="sub-title"
                          title={getCapitalizedSkillString(evalItem.skillarray)}
                        >
                          {getCapitalizedSkillString(evalItem.skillarray)}
                        </div>
                        <div className="sub-title">
                          Updated On: {evalItem.updatedby?.updatedon}
                        </div>
                      </div>
                      <div className="card-section-bottom">
                        <div className="content">
                          <div className="application-count">
                            <ClockCircleOutlined />{" "}
                            {evalItem.generalsetting.duration} mins
                          </div>
                          <div className="status">
                            {/* The Status Dot */}
                            <span
                              className="status-dot"
                              style={{
                                backgroundColor:
                                  evalItem?.state?.toLowerCase() === "live"
                                    ? "#52c41a"
                                    : "#bfbfbf",
                              }}
                            ></span>

                            {/* The Status Text */}
                            <span
                              style={{
                                color:
                                  evalItem?.state?.toLowerCase() === "offline"
                                    ? "grey"
                                    : "inherit",
                              }}
                            >
                              {evalItem.state}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card>
                </div>
              ))}
            </div>
          ) : (
            <Empty />
          )}
        </>
      )}

      <Pagination
        style={{ marginTop: "4px", float: "inline-end", marginBottom: "20px" }}
        current={currentPage} // Changed from hardcoded 1
        pageSize={limit}
        total={allGlobalEvalsPagination?.total}
        onChange={handlePageChange}
        showSizeChanger
        pageSizeOptions={[12, 20, 50, 100, 150]}
      />
    </div>
  );
}

export default GlobalEvaluation;
